import React, { useEffect, useState } from "react"
import Style from "./index.module.scss"

const Collapsible = props => {
  const { title, children, isOpenAccordian, customClassName = "" } = props
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(!isOpen)
  }
  useEffect(() => {
    setIsOpen(!!isOpenAccordian)
  }, [isOpenAccordian])
  return (
    <div className={`${Style.Collapsible} ${customClassName}`}>
      <div
        className={`header ${isOpen ? "open" : ""}`}
        tabIndex={"0"}
        onClick={handleClick}
        aria-expanded={isOpen}
        role="button"
      >
        {title}
      </div>
      {isOpen ? <div className="body">{children}</div> : null}
    </div>
  )
}

export default Collapsible
